import React, { FunctionComponent, ReactElement } from 'react'
import classNames from 'classnames'
import { Checkbox } from '@common/components'

import styles from './description-card.module.css'

export interface CardProps {
    icon?: string
    mainDescription?: string
    title?: string
    showCheckbox?: boolean
    cardTitle?: ReactElement | string
    cardDescription?: string
    onSelect?: (val: boolean) => void
    selected?: boolean
    id: string
    disabled: boolean
}

export const DescriptionWithCard: FunctionComponent<CardProps> = ({
    icon,
    mainDescription,
    title,
    cardDescription,
    showCheckbox,
    cardTitle,
    onSelect,
    selected,
    id,
    disabled,
}) => {
    const containerClassList = classNames({
        [styles.container]: true,
        [styles.disabled]: disabled,
    })

    const cardClassList = classNames({
        [styles.card]: true,
        [styles['card--selected']]: selected,
        [styles['card--no-desc']]: !cardDescription,
    })

    const checkboxClassList = classNames({
        [styles['card-checkbox']]: true,
        [styles['card-checkbox--no-desc']]: !cardDescription,
    })

    const onChangeFn = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (onSelect) onSelect(event.target.checked)
    }

    return (
        <div className={containerClassList} data-qat={`resolve-${id}-addon`}>
            {title && (
                <div className={styles.header}>
                    {icon && <img className={styles['header-img']} src={icon} alt="addon-icon" />}

                    <h4 className={styles['header-text']}>{title}</h4>
                </div>
            )}

            {mainDescription && <div className={styles.content}>{mainDescription}</div>}

            <div className={cardClassList} role="checkbox" aria-labelledby={id} aria-checked={selected}>
                {showCheckbox && (
                    <Checkbox
                        checked={selected}
                        id={id}
                        modifier={checkboxClassList}
                        onchange={onChangeFn}
                        qaTag={`customize-${id}-addon`}
                        disabled={disabled}
                    />
                )}
                <div>
                    <div className={styles['card-header']}>{cardTitle}</div>
                    {cardDescription && <div className={styles['card-description']}>{cardDescription}</div>}
                </div>
            </div>
        </div>
    )
}
